import React, { useEffect } from "react";

import { connect } from "react-redux";

import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";

import { clearData, downloadExportData, inputChangeValue } from "../../store/settings/ImportExport/actions";

import { getExportModelsList } from "../../store/settings/ImportExport/actions";

const ExportCSV = (props) => {
  useEffect(() => {
    console.log("🔍 ExportCSV Component Mounted");
    props.clearData();
    props.getExportModelsList();
  }, []);

  useEffect(() => {
    console.log("📊 exportData:", props.exportData);
    console.log("📊 exportModelList:", props.exportModelList);
  }, [props.exportData, props.exportModelList]);

  const data = [
    "Reaching the targets and goals set for my area.",
    "Servicing the needs of my existing customers.",
    "Maintaining the relationships with existing customers for repeat business.",
    "Reporting to top managers",
    "Keeping up to date with the products.",
  ];

  function exportData() {
    console.log("📤 [Component] exportData called");
    console.log("📤 [Component] exportData.model_name:", props.exportData.model_name);
    var objData = {
      model_name: props.exportData.model_name,
      file_format: 0,
    };
    console.log("📤 [Component] Sending objData:", objData);
    props.downloadExportData(objData);
  }

  return (
    <Card>
      <CardBody>
        <h4 className="mb-4">Export CSV</h4>
        <hr />
        <Form onSubmit={(e) => { e.preventDefault(); exportData(); }}>
          <Row>
            <Col md={6}>
              <h5>Before Export your file</h5>
              <ul>
                {data.map((item, key) => (
                  <li key={key}>{item}</li>
                ))}
              </ul>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label htmlFor="model_name">Select file type</Label>
                <Input
                  type="select"
                  name="model_name"
                  id="model_name"
                  onChange={(e) => {
                    props.inputChangeValue({
                      key: "model_name",
                      value: e.target.value,
                    });
                  }}
                  value={props.exportData.model_name || ""}
                >
                  <option value="">Select...</option>
                  {props.exportModelList?.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <Button
                color="primary"
                disabled={props.loading}
                onClick={() => {
                  if (props.exportData.model_name) {
                    exportData();
                  }
                }}
              >
                Export .csv file
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
};

function mapStateToProps({ importExportReducer }) {
  console.log("🔍 mapStateToProps - importExportReducer:", importExportReducer);
  return {
    exportData: importExportReducer.exportData,
    loading: importExportReducer.loading,
    exportModelList: importExportReducer.exportModelList,
  };
}

export default connect(mapStateToProps, {
  clearData,
  inputChangeValue,
  downloadExportData,
  getExportModelsList,
})(ExportCSV);
